import {FormikContextType, useFormikContext} from 'formik';
import React from 'react';
import {
  DisableFocusWrapper,
  Button,
  ButtonAppearance,
  ButtonType,
  TextColor,
  TextAppearance,
  Text,
  getInputTextElement,
  getRadioButtonGroupElement,
  getTextAreaInput,
  LegalFormDisclaimer
} from '@vw-marketing/us-components';
import {
  StyledFormTitle,
  StyledLegalDisclaimer,
  StyledForm,
  StyledFormsFieldsContainer,
  StyledFirstNameWrapper,
  StyledLastNameWrapper,
  StyledEmailWrapper,
  StyledPhoneWrapper,
  StyledContactMethodWrapper,
  StyledCommentsWrapper,
  StyledSubmitButton
} from './styles';

export interface DynamicFormProps {
  children?: React.ReactChild;
  requiredFields: any;
  formStructure?: string;
  columns?: number;
  submitLabel: string;
  legalDisclaimer: string;
  formName?: string;
  fieldsConfig?: any;
}

export const DynamicForm: React.FC<DynamicFormProps> = ({
  requiredFields,
  formStructure,
  children,
  columns,
  submitLabel,
  formName,
  legalDisclaimer,
  fieldsConfig
}): JSX.Element => {
  const props: FormikContextType<any> = useFormikContext();
  const {isSubmitting, handleSubmit, isValid} = props;
  const fields: any = fieldsConfig;

  const defaultStructure =
    '"model" "firstName" "lastName" "email" "phone" "myOffer" "monthlyFee" "contactMethod" "zip" "comments"';
  return (
    <>
      <StyledForm
        onSubmit={handleSubmit}
        name={formName}
        id={formName}
        className="dynamic-form"
      >
        <StyledFormTitle className="form-title">{children}</StyledFormTitle>
        <StyledFormsFieldsContainer
          structure={formStructure || defaultStructure}
          columns={columns || 1}
          className="form-fields"
        >
          {typeof requiredFields['firstName'] !== 'undefined' && (
            <StyledFirstNameWrapper className="form-field-first-name" >
              {getInputTextElement(fields.firstName, props)}
            </StyledFirstNameWrapper>
          )}

          {typeof requiredFields['lastName'] !== 'undefined' && (
            <StyledLastNameWrapper className="form-field-last-name">
              {getInputTextElement(fields.lastName, props)}
            </StyledLastNameWrapper>
          )}
          {typeof requiredFields['email'] !== 'undefined' && (
            <StyledEmailWrapper className="form-field-email" >
              {getInputTextElement(
                fields.email,
                props,
                typeof props.values.preferredContactMethod !== 'undefined' &&
                  ![fields.email.name, 'either'].includes(
                    props.values.preferredContactMethod
                  )
              )}
            </StyledEmailWrapper>
          )}
          {typeof requiredFields['phone'] !== 'undefined' && (
            <StyledPhoneWrapper className="form-field-phone" >
              {getInputTextElement(
                fields.phone,
                props,
                typeof props.values.preferredContactMethod !== 'undefined' &&
                  ![fields.phone.name, 'either'].includes(
                    props.values.preferredContactMethod
                  )
              )}
            </StyledPhoneWrapper>
          )}
          {typeof requiredFields['myOffer'] !== 'undefined' && (
            <StyledEmailWrapper className="form-field-myOffer" >
              {getInputTextElement(
                fields.myOffer,
                props
              )}
            </StyledEmailWrapper>
          )}
          {typeof requiredFields['monthlyFee'] !== 'undefined' && (
            <StyledEmailWrapper className="form-field-monthlyFee" >
              {getInputTextElement(
                fields.monthlyFee,
                props
              )}
            </StyledEmailWrapper>
          )}

          {typeof requiredFields['preferredContactMethod'] !== 'undefined' && (
            <StyledContactMethodWrapper className="form-field-contact-method" >
              {getRadioButtonGroupElement(fields.preferredContactMethod, props)}
            </StyledContactMethodWrapper>
          )}
          {typeof requiredFields['comments'] !== 'undefined' && (
            <StyledCommentsWrapper className="form-field-comments" >
              {getTextAreaInput(fields.comments, props)}
            </StyledCommentsWrapper>
          )}
        </StyledFormsFieldsContainer>
        <StyledLegalDisclaimer className="form-legal-disclaimer">
          <LegalFormDisclaimer disclaimer={legalDisclaimer} />
        </StyledLegalDisclaimer>
        <StyledSubmitButton className="form-submit-button" >
          <DisableFocusWrapper>
            {/* @ts-ignore */}
            <Button
              appearance={ButtonAppearance.Primary}
              type={ButtonType.Submit}
              disabled={isSubmitting || !isValid}
              stretchContent
            >
              <Text
                color={TextColor.inherit}
                appearance={TextAppearance.copy100}
              >
                {submitLabel || 'Submit'}
              </Text>
            </Button>
          </DisableFocusWrapper>
        </StyledSubmitButton>
      </StyledForm>
    </>
  );
};
